<template>
    <div class="jiancha">
        <el-select
                :value="value"
                :disabled="disabled"
                :class="getClass"
                placeholder="请选择"
                @input="change($event)"
        >
            <el-option
                    v-for="item in options"
                    :class="item.class"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        props: ["value", "disabled", "keys"],
        data() {
            return {
                options: [
                    {
                        class: "yangxing",
                        label: "阳性",
                        value: "阳性"
                    },
                    {
                        class: "yinxing",
                        label: "阴性",
                        value: "阴性"
                    },
                    {
                        class: "weixiang",
                        label: "未做",
                        value: "未做"
                    }
                ]
            };
        },
        computed: {
            getClass() {
                var flag = ''
                if (this.$store.state.registration.form9.indexOf('form4_' + this.keys) >= 0) {
                    flag = " container";
                }
                if (this.value == "阳性") {
                    return "select_yangxing " + flag;
                } else if (this.value == "阴性") {
                    return "select_yinxing " + flag;
                } else if (this.value == "未做") {
                    return "select_weixiang " + flag;
                } else return "select_weixuan " +flag;
            }
        },
        methods: {
            change: function (val) {
                this.$emit("input", val);
                this.$emit("checkPoints", val)
            },
        },
    };
</script>

<style scoped>
    .jiancha {
        padding-right: 10px;
    }

    .jiancha .el-select {
        width: 75px;
        color: white;
    }

    .jiancha /deep/ .el-select .el-input .el-select__caret {
        color: #fff;
        height: 20px;
        line-height: 20px;
    }

    .jiancha /deep/ .el-input__inner {
        border: none;
        /* padding: 0 5px; */
        padding-left: 15px;
        padding-right: 25px;
        height: 20px;
        line-height: 20px;
        color: white;
    }

    .jiancha /deep/ .el-input__inner::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #fff;
        /* placeholder字体大小  */
        font-size: 12px;
        /* placeholder位置  */
        text-align: right;
    }

    .yangxing {
        background-color: #f88;
        color: white;
    }

    .select_yangxing /deep/ .el-input__inner {
        background-color: #f88;
        color: white;
    }

    .yinxing {
        background-color: #528a36;
        color: white;

    }

    .select_yinxing /deep/ .el-input__inner {
        background-color: #67c23a;
    }

    .container /deep/ .el-input__inner {
        border: 1px solid red;
    }

    .weixiang {
        background-color: #999;
        color: white;
    }

    .select_weixiang /deep/ .el-input__inner {
        background-color: #909399;
        color: white;
    }

    .weixuan {
        background-color: #f7f7f8;
        color: white;
    }

    .select_weixuan /deep/ .el-input__inner {
        background-color: #f7f7f8;
        color: white;
    }

    .select_weixuan /deep/ .el-input__inner::-webkit-input-placeholder {
        background-color: #f7f7f8;
        color: #333 !important;
    }

    .select_weixuan /deep/ .el-select__caret {
        color: #333 !important;
    }
</style>
